export function numToFixed(num: number, precision = 2) {
	if (Number.isNaN(num)) {
		return null;
	}
	const multiplier = 10 ** precision;
	return Math.round((num + Number.EPSILON) * multiplier) / multiplier;
}
